<style>
    .k-grid .k-header {
        white-space: normal;}
    .errMsg { color: #FF0000; }
</style>
<div class="sendToInvoice" style="height: calc(100vh - 15px);" *ngIf="showSendToIntacctPanel"> 
	<div class="side-panel-content" [ngStyle]="{'width': showIntacctResponseSidePanel ? '1430px' : '800px'}"
        style="overflow-y: auto; overflow-x: hidden; display: flex; padding: 0 0px 0 0;">
        <div *ngIf="showIntacctResponseSidePanel" style="width: 600px; padding: 30px 0 0 0;">
            <div class="row" style="color: black; font-size: 30px;">
                <div class="col-md-12 align-center">
                    <label class="side-panel-header"><i class="fa fa-lg" style="padding-right: 1em;"></i>Intacct Response</label>
                </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: hidden; height: calc(100vh - 80px);">
                <kendo-grid 
                    [data]="intacctResponse" 
                    [loading]="sendingRequestToIntacct"
                    [ngStyle]="{height: 'calc(100vh - 80px)'}"
                    style="border: none; margin-left: 15px; margin-right: 0px;">
                    <kendo-grid-column field="message" title="Messages">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="whole-cell" [ngClass]="{'errMsg': dataItem.isError}">
                                {{ dataItem.message }}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
		</div>
		<div class="align-center side-panel-preview-separator"
            style="width: 30px; height: 100vh;" *ngIf="showIntacctResponseSidePanel"
            (click)="showIntacctResponseSidePanel = false;">
            <i class="fa fa-angle-right fa-2x" style="margin-top: calc(50vh - 30px);"></i>
        </div>
	 	<div style="height: 100vh; width: 800px; padding: 30px 0 0 0;"> 
			<div style="height: calc(100vh - 250px);">
				<div *ngIf="!isSent">
					<div class="row" style="color: black; font-size: 30px; height: 5vh;">
						<div class="col-md-10 align-center">
							<label class="side-panel-header" >
								<i class="fa fa-lg fa-share rail360-success" style="padding-right: 1em;"></i> Send to Intacct
							</label>
						</div>
						<div *ngIf="!sendingRequestToIntacct" class="col-md-2 align-center">
							<a class="side-panel-close" (click)="closeComponent()">X</a>
						</div>
					</div> 
					<div *ngIf="isMultiple">
						<div class="row" style="height: 65vh;">
							<div class="col-md-12 m-1" style="margin-top: 2vh;">
								<div class="row">
									<div class="col-md-8"></div>
									<div class="col-md-4 m-3">
										<label>Current Processing Period:</label><br>
										<label class="data">{{processingPeriod | date: 'MM/yyyy'}}</label>
									</div>
								</div>
								<div class="row" >
									<div class="col-md-12 m-1" >
										<h2 style="padding-left: 1em; margin-top: 10px;">Selected Invoices for Payment</h2>
									</div>
								</div>
								<kendo-grid [data]="selectedInvoices" [loading] = isLoadingIntacctData
									style="border: none;">
									<kendo-grid-column field="invoicingParty" title="Invoicing Party" width="70">
									</kendo-grid-column>
									<!-- <kendo-grid-column field="invoiceNumber" title="Invoice #">
									</kendo-grid-column> -->
									<kendo-grid-column *ngIf="page.toLocaleLowerCase() == 'storage'" field="billingMonth" title="Storage Month" type="date" width="120">
										<ng-template kendoGridCellTemplate let-dataItem>
											{{dataItem.billingMonth | date:'MMMM yyyy'}}
										</ng-template>
									</kendo-grid-column>
									<kendo-grid-column field="invoiceDate" title="Invoice Date" type="date" width="120">
										<ng-template kendoGridCellTemplate let-dataItem> 
											{{dataItem.invoiceDate | date:'MM/dd/yyyy'}}
										</ng-template>
									</kendo-grid-column>
									<kendo-grid-column *ngIf="page.toLocaleLowerCase() != 'storage'" field="accountingInvoiceDate" title="Invoice Received Date" type="date" width="120" >
										<ng-template kendoGridCellTemplate let-dataItem>
											{{dataItem.accountingInvoiceDate | date:'MM/dd/yyyy'}}
										</ng-template>
									</kendo-grid-column>
									<kendo-grid-column field="accountingDueDate" title="Invoice Due Date" width="140">
										<ng-template kendoGridCellTemplate let-dataItem>
											<kendo-datepicker style="width: 100%;" placeholder=" " formatPlaceholder="short"
												[format]="'MM/dd/yyyy'" [(value)]="dataItem.accountingDueDate">
											</kendo-datepicker>
										</ng-template>
									</kendo-grid-column>
									<kendo-grid-column field="glPostingDate" title="GL Posting Date" width="140">
										<ng-template kendoGridCellTemplate let-dataItem>
											<kendo-datepicker style="width: 100%;" placeholder=" " formatPlaceholder="short"
												[format]="'MM/dd/yyyy'" [(value)]="dataItem.glPostingDate">
											</kendo-datepicker>
										</ng-template>
									</kendo-grid-column>
								</kendo-grid>
							</div>
						</div>
					</div>
					<div *ngIf="!isMultiple">
						<div class="row row-controls" style="margin-top: 4vh;">
							<div class="col-md-3"></div>
							<div class="col-md-6">
								<label>Current Processing Period:</label><br>
								<label class="data">{{processingPeriod | date: 'MM/yyyy'}}</label>
							</div>
							<div class="col-md-3"></div>
						</div>
						<div class="row row-controls">
							<div class="col-md-3"></div>
							<div class="col-md-6">
								<label>Invoice Date:</label><br>
								<label class="data">{{selectedInvoice.invoiceDate | date: 'MM/dd/yyyy'}}</label>
							</div>
							<div class="col-md-3"></div>
						</div>
						<div class="row row-controls">
							<div class="col-md-3"></div>
							<div class="col-md-6">
								<label>Invoice Due Date:</label>
								<kendo-datepicker style="width: 100%;" [(value)]="selectedInvoice.accountingDueDate"></kendo-datepicker>
							</div>
							<div class="col-md-3"></div>
						</div>
						<div class="row row-controls">
							<div class="col-md-3"></div>
							<div class="col-md-6">
								<label>GL Posting Date:</label>
								<kendo-datepicker style="width: 100%;" [min]="processingPeriod" [(value)]="selectedInvoice.glPostingDate"></kendo-datepicker>
							</div>
							<div class="col-md-3"></div>
						</div>
					</div>
				</div>
				<div *ngIf="isSent">
					<div class="row" style="color: black; font-size: 30px; height: 10vh;">
						<div class="col-md-10 align-center">
							<label class="side-panel-header" >
								<i class="fa fa-lg fa-share fa-flip-horizontal" style="padding-right: 1em;"></i> Reverse Invoice 
							</label>
						</div>
						<div *ngIf="!sendingRequestToIntacct" class="col-md-2 align-center">
							<a class="side-panel-close" (click)="closeComponent()">X</a>
						</div>
					</div> 
					<div class="row">
						<div class="col-md-12">
							<div style="margin-top: 4vh;">
								<div class="row">
									<div class="row row-controls">
										<div class="col-md-3"></div>
										<div class="col-md-6">
											<label>Current Processing Period:</label><br>
											<label class="data">{{processingPeriod | date: 'MM/yyyy'}}</label>
										</div>
										<div class="col-md-3"></div>
									</div>
									<div class="row row-controls">
										<div class="col-md-3"></div>
										<div class="col-md-6">
											<label>GL Posting Date:</label><br>
											<label class="data">{{selectedInvoice.glPostingDate | date: 'MM/dd/yyyy'}}</label>
										</div>
										<div class="col-md-3"></div>
									</div>
									<div class="row row-controls">
										<div class="col-md-3"></div>
										<div class="col-md-6">
											<label>Payment Status:</label><br>
											<label class="data">{{selectedInvoice.purchaseOrderPaymentStatus}}</label>
										</div>
										<div class="col-md-3"></div>
									</div>
									<div class="row row-controls">
										<div class="col-md-3"></div>
										<div class="col-md-6">
											<label>State:</label><br>
											<label class="data">{{selectedInvoice.purchaseOrderState}}</label>
										</div>
										<div class="col-md-3"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="isLoadingIntacctData && !isMultiple" style="text-align: center;">
					<span class="k-icon k-i-loading" style="font-size: 42px;" [ngStyle]="{'margin-top': getMarginAboveGrid()}"></span>
				</div>
			</div>
			<div class="col-md-12 align-center">
				<div class="row" style="margin-top: 4vh;">
					<div class="col-md-3"></div>
					<div class="col-md-6">
						<button name="sendToIntacct" id="SendToIntacct" *ngIf="!isSent"
							class="btn rail360-primary-item btn-rectangle-lg" (click)="sendToIntacct()"
							[disabled]="isLoadingIntacctData || disableSendToIntacct || lockActions">
							Send To Intacct</button>
						<button name="reverseFromIntacct" id="ReverseFromIntacct" *ngIf="isSent"
							class="btn rail360-danger-item btn-rectangle-lg" (click)="reverseFromIntacct()"
							[disabled]="isLoadingIntacctData || lockActions || !processingPeriod || !canReverse">
							Reverse Payable</button>
					</div>
					<div class="col-md-3"></div>
				</div>
			</div>
	 	</div>
	</div>
</div>
